import en from "../content/en.js";
import { whatsappTo } from "../shared/links.js";
import { HERO_SLIDES, type V2Content } from "./content.js";

const content: V2Content = {
  ...en,
  meta: {
    ...en.meta,
    title: "Kuori — the whole event, through the people in it",
  },
  nav: { ...en.nav, short: "Get started" },
  menu: {
    product: "Product",
    explore: "Explore Kuori",
    items: [
      {
        href: "#como",
        icon: "qr",
        title: "How it works",
        body: "From QR code to big screen, in seconds.",
      },
      {
        href: "#produto",
        icon: "monitor",
        title: "The big screen",
        body: "Reveal as they arrive or at the end. Hide from your phone.",
      },
      {
        href: "#album",
        icon: "images",
        title: "The album",
        body: "Ready the next day, hour by hour.",
      },
      {
        href: "#marca",
        icon: "palette",
        title: "White label",
        body: "Your name and your color on the invite and the screen.",
      },
    ],
    links: [
      {
        href: whatsappTo("Hi! I would like a quote from Kuori for my event."),
        icon: "whatsapp",
        title: "Get a quote",
        external: true,
      },
      { href: "#faq", icon: "help", title: "FAQ" },
    ],
    start: "Get started",
    startHref: whatsappTo("Hi! I want to start using Kuori."),
    talk: "Talk to Kuori",
  },
  hero: {
    ...en.hero,
    sub: "Guests point their camera at the QR code, shoot from the browser, and the photo reaches the album and the big screen in seconds. Nothing to install.",
    alt: "See how it works",
    slides: HERO_SLIDES,
  },
  live: {
    label: "Big screen · example",
    event: "Leo & Day's wedding",
    live: "live",
    count: "photos in the album",
    sent: "sent a photo",
    minutes: "{n} min ago",
    join: "Point your camera at the QR code",
  },
  numbers: [
    { value: 0, label: "apps for guests to install" },
    { value: 1, label: "QR code for the whole event, from invite to big screen" },
    { value: 60, unit: "s", label: "to create the event and print the QR code" },
  ],
  flow: {
    label: "How it works",
    title: "From QR code to big screen, in seconds.",
    steps: [
      {
        tag: "Scan",
        title: "The QR code opens the event.",
        body: "It goes on the invite, the table card, and the big screen. The phone camera recognizes it and opens the event in the browser.",
      },
      {
        tag: "Join",
        title: "First and last name. That's it.",
        body: "No sign-up, no password, no app. It even works from inside WhatsApp and Instagram.",
      },
      {
        tag: "Shoot",
        title: "The event camera, right away.",
        body: "Each guest gets a set number of photos. Every photo keeps its original quality, with no group-chat compression.",
      },
      {
        tag: "On screen",
        title: "And everyone sees it.",
        body: "The photo goes into the album and shows up on the big screen with the name of who took it, while the event is happening.",
      },
    ],
    scan: "Leo & Day's wedding",
    open: "Open in browser",
    invitedBy: "Invited by",
    headline: ["The event's photos, ", "by you"],
    first: "First name",
    last: "Last name",
    guest: ["Ana", "Souza"],
    enter: "Join the event",
    noApp: "No app to install.",
    left: "8 of 10 photos",
    sentToWall: "Sent. It's on the big screen.",
    hint: "Scroll to continue",
    nudge: "Swipe to see the next step",
    nudgeLast: "Keep scrolling",
    scrollNext: "Scroll to the next step",
    scrollCue: "Scroll",
    next: "Next",
    stepOf: "{n} of {total}",
  },
  wall: {
    live: "live",
    count: "Photos in the album",
    now: "Just now",
    join: "Join the album and send your photo",
    point: "point your camera",
    madeWith: "made with",
    waiting: "Photos appear at 11 PM",
    kept: "photos saved for the reveal",
    label:
      "Big screen illustration: the latest photo featured, earlier ones beside it, and the event QR code",
  },
  control: {
    label: "On the day",
    title: "The big screen answers to you.",
    body: "Reveal photos as they arrive or only at the end. Hide a photo in seconds from your phone, and it leaves the screen right away. Try it here.",
    reveal: "Reveal",
    revealNow: "As they arrive",
    revealEnd: "At the end",
    revealNowHint: "Each photo shows up on the screen as soon as it arrives.",
    revealEndHint: "Photos are held back and appear together at the end.",
    recent: "Recent photos",
    hide: "Hide",
    show: "Show",
    hidden: "Hidden",
    hideLabel: "Hide {name}'s photo",
    showLabel: "Show {name}'s photo",
    event: "Leo & Day's wedding",
  },
  album: {
    label: "Afterwards",
    title: "The album, ready hour by hour.",
    body: "The next day, every photo is in the album, grouped by the hour it was taken and in original quality. Tap an hour.",
    all: "All",
    photos: "photos",
    original: "Original quality",
  },
  studio: {
    label: "White label",
    title: "Your name in front. Ours out of the way.",
    body: "Event professionals deliver Kuori under their own name and color, on the invite and on the big screen. Change them below and see.",
    names: ["Atelier Marília", "Studio Aurora", "Casa Lume"],
    nameLabel: "Name",
    colorLabel: "Color",
    colorNames: { pink: "Pink", blue: "Blue", green: "Green", amber: "Amber", ink: "Black" },
    demo: {
      cta: "Try the demo (in Portuguese)",
      note: "The full demo starts with the name and color you picked. About two minutes, no sign-up.",
      qrTitle: "Rather use your phone?",
      qrBody: "Point your camera here to open the demo.",
    },
  },
  ending: {
    title: "Shall we capture your next event?",
    note: "We reply the same business day.",
    action: "Message us on WhatsApp",
    rights: "2026 Kuori",
  },
};

export default content;
